import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AlertController, LoadingController } from "ionic-angular";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { PopoverController } from "ionic-angular";
import { SearchComponent } from "../../components/searchcomponent/searchcomponent";
import { Member } from "../../models/interfaces/member.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

import { Hareline } from "../../models/interfaces/hareline.model";

@Component({
  selector: "page-attendance_add",
  templateUrl: "attendance_add.html",
})
export class AttendanceAddPage {

  private loading: any;
  private attendanceForm: FormGroup;
  private member: Member;
  private hareline: Hareline;

  private smember = [];
  private styleName: string ="";

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController,
    public navParams: NavParams, private formBuilder: FormBuilder,
    private toastCtrl: ToastController, private db: DbserviceProvider,
    public alertCtrl: AlertController, public loadingCtrl: LoadingController,
    public popoverCtrl: PopoverController) {
    console.log("AttendanceAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

    this.hareline = this.navParams.get("hareline");
    this.attendanceForm = this.formBuilder.group({
      "at_confirmed_flg": [""],
      "mb_hashname": [""]
    });
  }

  private ionViewWillEnter() {
    console.log("AttendanceAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("AttendanceAddPage onInitPage");
  }

  private selectMember() {
    console.log("AttendanceAddPage selectMember");
    let selection = this.popoverCtrl.create(SearchComponent, { "obs": "member", "sel": this.smember, "type": "c" });
    selection.present();
    selection.onDidDismiss((data) => {
      if (data != null) {
        this.smember = [];
        for (let key in data) {
          this.smember.push(key);
        }
      }
    });
  }

  private goback() {
    console.log("AttendanceAddPage goback");
    this.navCtrl.pop();
  }

  private ngOnDestroy() {
    console.log("AttendanceAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/components/attendancecomponent/attendance_add.ts